import axios from 'axios'
import config from './config'

const getBaseUrl = () => {
  if (process.env.REACT_APP_NODE_ENV === 'production') {
    return config.prod.API_BASE
  }
  if (process.env.REACT_APP_NODE_ENV === 'test') {
    return config.test.API_BASE
  }
  return config.dev.API_BASE
}

const Axios = axios.create({
  baseURL: getBaseUrl(),
  timeout: 0,
  mode: 'no-cors',
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
  headers: {
    'Access-Control-Allow-Origin': '*',
    Authorization: `Bearer ${window.localStorage.getItem('token')}`
  }
})

Axios.interceptors.request.use(
  (settings) => {
    const token = `Bearer ${window.localStorage.getItem('token')}`
    if (token) {
      settings.headers.Authorization = token
    }
    return settings
  },
  (error) => {
    Promise.reject(error)
  }
)

Axios.defaults.headers.common['Content-Type'] = 'application/json'

export default Axios
